import {createSlice} from "@reduxjs/toolkit";
import {DEFAULT_RESULTS_PER_PAGE} from "models/options";

const initialState = {
  error: false,
  hasZeroResults: false,
  loadedResults: [],
  loading: false,
  pageCount: DEFAULT_RESULTS_PER_PAGE,
  reset: false,
  searchText: "",
  totalRows: 0
};

export const savedInvestigations = createSlice({
  name: "savedInvestigations",
  initialState,
  reducers: {
    fetchSavedInvestigations: (state, action) => {
      state.error = false;
      state.loading = true;
      state.pageCount = action.payload.pageCount;
    },
    fetchSavedInvestigationsSuccess: (state, action) => {
      state.totalRows = action.payload.totalRows;
      state.searchText = action.payload.searchText;
      state.loading = false;
      state.loadedResults = action.payload.dataRows;
      state.reset = false;
      state.hasZeroResults = action.payload.dataRows.length === 0;
    },
    fetchSavedInvestigationsFailure: (state) => {
      state.loadedResults = [];
      state.error = true;
      state.loading = false;
      state.hasZeroResults = true;
    },
    bulkDeleteSavedInvestigations: (state) => {
      state.loading = true;
    },
    bulkDeleteSavedInvestigationsSuccess: (state, action) => {
      // Will dispatch thunk which fetches new investigations
      state.error = false;
      state.loading = true;
      state.pageCount = action.payload.pageCount;
    },
    bulkDeleteSavedInvestigationsFailure: (state) => {
      state.loading = false;
    }
  }
});

export const {
  fetchSavedInvestigations,
  fetchSavedInvestigationsSuccess,
  fetchSavedInvestigationsFailure,
  bulkDeleteSavedInvestigations,
  bulkDeleteSavedInvestigationsSuccess,
  bulkDeleteSavedInvestigationsFailure
} = savedInvestigations.actions;

export default savedInvestigations.reducer;
